//@flow
import type { ReducerState,EditFormData } from './flowTypes'

export const transformFormDataToEditMode=(data:any,kratosec: ReducerState)=>{
    let formData:EditFormData = {}
    formData.isDocInvalid = data['is_doc_invalid']
    formData.isDocNotLoad = data['is_doc_not_load']

    return formData
}


// WEBPACK FOOTER //
// ./src/redux/kratosec/editFormData.js